module.exports = __webpack_public_path__ + "img/registerwifidevice.4e6d0a1b.png";